import { onError } from "apollo-link-error";
import isMaintenanceError from "../isMaintenanceError";

const detectMaintenanceErrors = (graphQLErrors) =>
  graphQLErrors && graphQLErrors.some(isMaintenanceError);

export default ({ onMaintenanceError }) =>
  onError(({ graphQLErrors, networkError, operation }) => {
    if (!process.env.SERVER) {
      const error = `GraphQL: An error occurred for request ${
        operation.operationName
      } (variables: ${JSON.stringify(operation.variables)})\n`;

      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, ...rest }) => {
          console.error(error, `GraphQL Error: ${message}\n`, rest);
        });
      }

      if (networkError) {
        console.error(error, `Network Error: ${networkError}`);
      }
    }

    if (
      detectMaintenanceErrors(graphQLErrors) ||
      networkError?.statusCode === 503
    ) {
      onMaintenanceError();
    }
  });
